import { h } from './dom';

const FMT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Amsterdam',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const fmtTime = (d: Date) => `${FMT.format(d)} AMS`;

export function Ticker(): HTMLElement {
  const time = h('span', {}, fmtTime(new Date()));
  setInterval(() => { time.textContent = fmtTime(new Date()); }, 1000);

  return h('div', { class: 's-ticker' },
    h('span', { class: 'live' }, 'studio open'),
    h('span', {}, 'build_1207'),
    h('span', {}, 'commit a3f9c2'),
    time,
    h('span', { style: 'margin-left: auto' }, 'booked → q3 · accepting briefs for q4'),
  );
}
